import React, { JSX } from 'react';
import {
  Field,
  ImageField,
  Link,
  LinkField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ItemValue } from 'components/types/ListItem';
import ArticleSummary from '../organisms/ArticleSummary';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type ArticleSummary = {
  id: string;
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseSummary: Field<string>;
    BaseImage: ImageField;
    BaseImageRight: {
      value: boolean;
    };
    BaseDate: Field<string>;
    BaseLocation: Field<string>;
    BaseHeading: Field<string>;
    BaseLink: LinkField;
    BasePhoneNumber: Field<string>;
    BaseLinkType: ItemValue;
  };
};

type ArticleSummaryComponentProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseBackground: {
      value: boolean;
    };
    BaseVertical: {
      value: boolean;
    };
    BaseViewMoreLink: LinkField;
    BasePhoneNumber: Field<string>;
    children: Array<ArticleSummary>;
  };
};

const ArticleSummaryComponent = (
  props: ArticleSummaryComponentProps
): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );

  const { fields } = props;

  const parentPhoneNumber =
    fields?.BasePhoneNumber?.value?.trim();

  const parentLinkText =
    fields?.BaseViewMoreLink?.value?.text?.trim();

  return (
    <div
      className={classNames('mx-0 row overhauled', marginSize)}
      id={`article-summary-component-${props.rendering?.uid}`}
    >
      <div
        className={
          fields.BaseBackground?.value === true
            ? fields.BaseVertical?.value === true
              ? 'article-summary-wrapper bg-secondary inner-vertical-spacing'
              : 'article-summary-wrapper bg-secondary'
            : 'article-summary-wrapper'
        }
      >
        <div className="jss-inner-container">
          <div
            className={
              fields.BaseVertical?.value === true
                ? 'vertical article-summaries'
                : 'article-summaries'
            }
          >
            {fields?.children?.map(({ id, fields }, index) => (
              <div
                key={id}
                className="article-summary-outer"
              >
                <ArticleSummary
                  id={id}
                  summary={fields?.BaseSummary?.value}
                  image={fields?.BaseImage}
                  imageRight={fields?.BaseImageRight?.value}
                  date={fields?.BaseDate?.value}
                  location={fields?.BaseLocation?.value}
                  heading={fields?.BaseHeading?.value}
                  link={fields?.BaseLink}
                  phoneNumber={fields?.BasePhoneNumber?.value}
                  linkType={fields?.BaseLinkType?.name}
                  imgAlt={`articles_image_${index + 1}`}
                  marginSize={
                    fields?.MarginSize?.fields?.heading?.value
                  }
                />
              </div>
            ))}
          </div>

          {(parentPhoneNumber ||
            fields?.BaseViewMoreLink?.value?.href) && (
            <div className="view-more">
              {parentPhoneNumber ? (
                <a
                  href={`tel:${parentPhoneNumber}`}
                  className="btn-primary"
                >
                  {parentLinkText || parentPhoneNumber}
                </a>
              ) : (
                <Link
                  className="btn-primary"
                  field={fields.BaseViewMoreLink}
                />
              )}

              <div className="divider"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleSummaryComponent;
